import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import LoadScript from 'react-load-script';
import React, { useEffect, useState } from 'react';
import { googleIdMobilePay, googleWebPay, merchantId } from '../../../../util';

var GooglePayComponent = function GooglePayComponent(props) {
  /**
    * Define the version of the Google Pay API referenced when creating your
    * configuration
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|apiVersion in PaymentDataRequest}
    */
  var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
  };
  /**
    * Card networks supported by your site and your gateway
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
    * @todo confirm card networks supported by your site and gateway
    */

  var allowedCardNetworks = ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'];
  /**
    * Card authentication methods supported by your site and your gateway
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
    * @todo confirm your processor supports Android device tokens for your
    * supported card networks
    */

  var allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
  /**
    * Identify your gateway and your site's gateway merchant identifier
    *
    * The Google Pay API response will return an encrypted payment method capable
    * of being charged by a supported gateway after payer authorization
    *
    * @todo check with your gateway on the parameters to pass
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#gateway|PaymentMethodTokenizationSpecification}
    */

  var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
      "gateway": "".concat(googleWebPay.gateway),
      "gatewayMerchantId": "".concat(googleWebPay.gatewayMerchantId)
    }
  };
  /**
    * Describe your site's support for the CARD payment method and its required
    * fields
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
    */

  var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: allowedCardAuthMethods,
      allowedCardNetworks: allowedCardNetworks,
      billingAddressRequired: true,
      // Require billing address
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true
      }
    }
  };
  /**
    * Describe your site's support for the CARD payment method including optional
    * fields
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#CardParameters|CardParameters}
    */

  var cardPaymentMethod = Object.assign({}, baseCardPaymentMethod, {
    tokenizationSpecification: tokenizationSpecification
  });
  /**
    * An initialized google.payments.api.PaymentsClient object or null if not yet set
    *
    * @see {@link getGooglePaymentsClient}
    */

  var paymentsClient = null;
  /**
    * Configure your site's support for payment methods supported by the Google Pay
    * API.
    *
    * Each member of allowedPaymentMethods should contain only the required fields,
    * allowing reuse of this base request when determining a viewer's ability
    * to pay and later requesting a supported payment method
    *
    * @returns {object} Google Pay API version, payment methods supported by the site
    */

  function getGoogleIsReadyToPayRequest() {
    return Object.assign({}, baseRequest, {
      allowedPaymentMethods: [baseCardPaymentMethod]
    });
  }
  /**
    * Configure support for the Google Pay API
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#PaymentDataRequest|PaymentDataRequest}
    * @returns {object} PaymentDataRequest fields
    */


  function getGooglePaymentDataRequest() {
    var paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.merchantInfo = {
      // @todo a merchant ID is available for a production environment after approval by Google
      // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist|Integration checklist}
      merchantId: "".concat(googleWebPay.merchantId),
      merchantName: 'Cracker Barrel'
    };
    paymentDataRequest.callbackIntents = ['PAYMENT_AUTHORIZATION'];
    return paymentDataRequest;
  }
  /**
    * Return an active PaymentsClient or initialize
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/client#PaymentsClient|PaymentsClient constructor}
    * @returns {google.payments.api.PaymentsClient} Google Pay API client
    */


  function getGooglePaymentsClient() {
    if (paymentsClient === null) {
      paymentsClient = new google.payments.api.PaymentsClient({
        environment: "".concat(googleWebPay.environment),
        paymentDataCallbacks: {
          onPaymentAuthorized: onPaymentAuthorized
        }
      });
    }

    return paymentsClient;
  }
  /**
   * Handles authorize payments callback intents.
   *
   * @param {object} paymentData response from Google Pay API after a payer approves payment through user gesture.
   * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData object reference}
   *
   * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentAuthorizationResult}
   * @returns Promise<{object}> Promise of PaymentAuthorizationResult object to acknowledge the payment authorization status.
   */


  function onPaymentAuthorized(paymentData) {
    var button = document.querySelector('#googlePayButton button');
    return new Promise(function (resolve, reject) {
      // handle the response
      var validateCart = window.localStorage.getItem('validateCart');

      if (!validateCart || validateCart === 'false') {
        console.info('Transaction canceled due a cart validation fail');
        button.disabled = false;
        resolve({
          transactionState: 'CANCELED',
          error: {
            intent: 'PAYMENT_AUTHORIZATION',
            message: 'Transaction canceled due a cart validation fail.',
            reason: 'PAYMENT_DATA_INVALID'
          }
        });
        return;
      }

      processPayment(paymentData).then(function (paymentData) {
        var data = JSON.parse(window.localStorage.getItem('digitalWalletValues'));
        props.handleSubmitCart(data.values, paymentData).then(function () {
          button.disabled = false;
        });
        resolve({
          transactionState: 'SUCCESS'
        });
      }).catch(function (err) {
        button.disabled = false;
        console.error('Error on Google Pay Flow:', err);
        resolve({
          transactionState: 'ERROR',
          error: {
            intent: 'PAYMENT_AUTHORIZATION',
            message: 'Insufficient funds, try again. Next attempt should work.',
            reason: 'PAYMENT_DATA_INVALID'
          }
        });
      });
    });
  }
  /**
    * Initialize Google PaymentsClient after Google-hosted JavaScript has loaded
    *
    * Display a Google Pay payment button after confirmation of the viewer's
    * ability to pay.
    */


  function onGooglePayLoaded() {
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest()).then(function (response) {
      if (response.result) {
        addGooglePayButton(); // @todo prefetch payment data to improve performance after confirming site functionality

        prefetchGooglePaymentData();
      }
    }).catch(function (err) {
      // show error in developer console for debugging
      console.error(err);
    });
  }
  /**
    * Add a Google Pay purchase button alongside an existing checkout button
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#ButtonOptions|Button options}
    * @see {@link https://developers.google.com/pay/api/web/guides/brand-guidelines|Google Pay brand guidelines}
    */


  function addGooglePayButton() {
    var paymentsClient = getGooglePaymentsClient();
    var button = paymentsClient.createButton({
      buttonType: 'pay',
      buttonSizeMode: 'fill',
      onClick: function onClick() {
        return onGooglePaymentButtonClicked();
      }
    });
    document.getElementById('googlePayButton').appendChild(button);
  }
  /**
    * Provide Google Pay API with a payment amount, currency, and amount status
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/request-objects#TransactionInfo|TransactionInfo}
    * @returns {object} transaction info, suitable for use as transactionInfo property of PaymentDataRequest
    */


  function getGoogleTransactionInfo() {
    var data = JSON.parse(window.localStorage.getItem('digitalWalletValues'));
    return {
      countryCode: 'US',
      currencyCode: 'USD',
      totalPriceStatus: 'FINAL',
      // set to cart total
      totalPrice: data.total.toFixed(2),
      totalPriceLabel: 'Total'
    };
  }
  /**
    * Prefetch payment data to improve performance
    *
    * @see {@link https://developers.google.com/pay/api/web/reference/client#prefetchPaymentData|prefetchPaymentData()}
    */


  function prefetchGooglePaymentData() {
    var paymentDataRequest = getGooglePaymentDataRequest(); // transactionInfo must be set but does not affect cache

    paymentDataRequest.transactionInfo = {
      totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
      currencyCode: 'USD'
    };
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.prefetchPaymentData(paymentDataRequest);
  }
  /**
    * Show Google Pay payment sheet when Google Pay payment button is clicked
    */


  function onGooglePaymentButtonClicked() {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var button, validate, paymentDataRequest, _paymentsClient;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              button = document.querySelector('#googlePayButton button');
              button.disabled = true;
              _context.prev = 2;
              props.placeOrderClick();
              _context.next = 6;
              return props.validateForm();

            case 6:
              validate = _context.sent;

              if (!(Object.keys(validate).length > 0)) {
                _context.next = 11;
                break;
              }

              Object.keys(validate).forEach(function (key) {
                props.setFieldTouched(key, true);
              });
              button.disabled = false;
              return _context.abrupt("return");

            case 11:
              window.localStorage.setItem('validateCart', false);
              props.submitForm().then(function (response) {
                if (!response) {
                  window.localStorage.setItem('validateCart', false);
                  button.disabled = false;
                } else {
                  window.localStorage.setItem('validateCart', true);
                }
              });
              paymentDataRequest = getGooglePaymentDataRequest();
              paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
              _paymentsClient = getGooglePaymentsClient();

              _paymentsClient.loadPaymentData(paymentDataRequest).catch(function (e) {
                button.disabled = false;
                console.error(e);
              });

              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](2);
              button.disabled = false;
              console.error('Error on Google Pay Flow:', _context.t0.message);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 19]]);
    }))();
  }
  /**
    * Process payment data returned by the Google Pay API
    *
    * @param {object} paymentData response from Google Pay API after user approves payment
    * @see {@link https://developers.google.com/pay/api/web/reference/response-objects#PaymentData|PaymentData object reference}
    */


  function processPayment(paymentData) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        // @todo pass payment token to your gateway to process payment
        var paymentToken = paymentData.paymentMethodData.tokenizationData.token;
        resolve(_objectSpread({}, paymentData));
      }, 500);
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://pay.google.com/gp/p/js/pay.js",
    onLoad: function onLoad() {
      onGooglePayLoaded();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: 'cb-checkout__google-pay-button',
    id: "googlePayButton"
  }));
};

export { GooglePayComponent };